module.exports = __webpack_public_path__ + "img/aws-white.89d954ea.png";